// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 1.58594L19.4142 9.00015H21V11.0002H20V20.0002H22V22.0002H2V20.0002H4V11.0002H3V9.00015H4.58579L12 1.58594ZM6 11.0002V20.0002H11V11.0002H6ZM13 11.0002V20.0002H18V11.0002H13Z"}}]};

const TempleFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'temple-filled',
    ref,
    icon: element,
  },
));

TempleFilledIcon.displayName = 'TempleFilledIcon';

export default TempleFilledIcon;
